import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

import { GET_CUSTOMER, SET_BILLING_DAY } from '../../../shared';
import LoadingSpinnerIcon from '../../../icons/LoadingSpinnerIcon';
import { StyledBillingDayDisplayContainer } from './DigitalPaymentBillingDay.styled';
import GreenTickIcon from '../../../icons/GreenTickIcon';

export default function DigitalPaymentBillingDay(props) {
  const { billingDay } = props;

  const intl = useIntl();

  const [changeBillingDay, { data, loading, error }] = useMutation(SET_BILLING_DAY, {
    refetchQueries: [{ query: GET_CUSTOMER }],
  });

  const [showSpinnerForSomeTime, setShowSpinnerForSomeTime] = useState(false);
  const [showSuccessIcon, setShowSuccessIcon] = useState(false);

  useEffect(() => {
    if (loading) {
      setShowSpinnerForSomeTime(true);

      setTimeout(() => {
        setShowSpinnerForSomeTime(false);
      }, 500);
    }
  }, [loading]);

  const changeSuccessful = data?.changeContractBillingDay?.status === 'success';

  useEffect(() => {
    if (changeSuccessful) {
      setShowSuccessIcon(true);
    }
  }, [changeSuccessful]);

  const handleBillingDayChange = (event) => {
    const newBillingDay = event.target.value;

    if (Number.isInteger(newBillingDay)) {
      changeBillingDay({
        variables: {
          billingDay: newBillingDay,
        },
      });
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="select_billing_day_label">
        <Typography variant="h3" component="span">
          <FormattedMessage id="policy.details.billing.info.edit_billing_day" />
        </Typography>
      </InputLabel>

      <Select
        labelId="select_billing_day_label"
        id="select_billing_day"
        value={billingDay}
        label={intl.formatMessage({
          id: 'policy.details.billing.info.edit_billing_day',
        })}
        onChange={handleBillingDayChange}
        onBlur={() => setShowSuccessIcon(false)}
        renderValue={(value) => (
          <StyledBillingDayDisplayContainer>
            <Typography
              variant="p"
              color={
                loading || showSpinnerForSomeTime ? 'professional_light_blue' : 'professional_blue'
              }
              component="span"
            >
              <FormattedMessage id={`policy.details.billing_day.${value}`} />
            </Typography>

            {(loading || showSpinnerForSomeTime) && <LoadingSpinnerIcon />}

            {!loading && !showSpinnerForSomeTime && showSuccessIcon && <GreenTickIcon />}
          </StyledBillingDayDisplayContainer>
        )}
        error={Boolean(!loading && error)}
      >
        <MenuItem value={1} disabled={billingDay === 1}>
          <Typography variant="p">
            <FormattedMessage id={`policy.details.billing_day.${1}`} />
          </Typography>
        </MenuItem>

        <MenuItem value={15} disabled={billingDay === 15}>
          <Typography variant="p">
            <FormattedMessage id={`policy.details.billing_day.${15}`} />
          </Typography>
        </MenuItem>
      </Select>

      {!loading && error && (
        <FormHelperText error>
          <Typography variant="p" color="error" component="span">
            <FormattedMessage id="policy.details.billing_day.change_error" />
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  );
}
